export default {

  namespaced: true,

  state: () => ({


  }),

  mutations: {
    userHasLoggedIn(state, { userId, userEmail, companyName }) {
      
      mixpanel.identify(userId);

      mixpanel.people.set({
        "$email": userEmail,  
        "company" : companyName
      });

      mixpanel.track('userHasLoggedIn');
    }
  },

  actions: {

  }
}